import { render } from "./AggregateTable.vue?vue&type=template&id=0405aafc"
import script from "./AggregateTable.vue?vue&type=script&lang=js"
export * from "./AggregateTable.vue?vue&type=script&lang=js"

import "./AggregateTable.vue?vue&type=style&index=0&id=0405aafc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__